import { UserRole } from '../types/auth';

/**
 * バックエンドのロール文字列をフロントエンドのUserRole型に変換
 * @param backendRole バックエンドから受け取ったロール値
 * @returns マッピングされたフロントエンドUserRole
 */
export const mapBackendRoleToFrontend = (backendRole?: string): UserRole => {
  switch (backendRole) {
    case 'admin':
      return 'admin';
    case 'editor':
      return 'editor';
    case 'viewer':
      return 'viewer';
    case 'schedule_checker':
      return 'schedule_checker';
    default:
      return 'guest';
  }
};

/**
 * ロール名を日本語表示用にマッピング
 * @param role ユーザーロール
 * @returns 日本語のロール名
 */
export const getRoleDisplayName = (role: UserRole): string => {
  switch (role) {
    case 'admin':
      return '管理者';
    case 'editor':
      return '編集者';
    case 'viewer':
      return '閲覧者';
    case 'schedule_checker':
      return '空き確認';
    case 'guest':
    default:
      return 'ゲスト';
  }
};
